import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../Baseurl";
import axiosInstance from "../api/axiosInstance";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const Patientbarchart = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const getFontSize = () => {
    if (windowWidth > 3000) return 24;
    if (windowWidth > 2500) return 19;
    if (windowWidth >= 2000) return 15;
    if (windowWidth >= 1600) return 13;
    return 11;
  };
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Patients",
        data: [],
        backgroundColor: ["#3f75c7", "#ffc107", "#28a745", "#6f42c1"],
        borderRadius: 4,
        barPercentage: 0.7,
        categoryPercentage: 0.7,
      },
    ],
  });
  const [loading, setLoading] = useState(true);
  const fetchChartData = async () => {
    try {
      const response = await axiosInstance.get(
        `dashboard/patients/age_bar_chart`
      );
      if (response.status === 200 && response.data.success) {
        const data = response.data.data || [];
        setChartData({
          labels: data.map((item) => item.label || "Unknown"),
          datasets: [
            {
              label: "Patients",
              data: data.map((item) => item.value || 0),
              backgroundColor: ["#4680ff", "#e58a00", "#318965", "#ff4c97ff"],
              borderRadius: 4,
              barPercentage: 0.7,
              categoryPercentage: 0.7,
            },
          ],
        });
      }
    } catch (err) {
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchChartData();
  }, []);
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        labels: {
          font: {
            size: getFontSize(), // ✅ Dynamic legend font size
          },
          color: "#333",
        },
      },
      title: { display: false },
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: "Age Group",
          font: {
            size: getFontSize(), // ✅ X-axis title font
            weight: "bold",
          },
          color: "#333",
        },
        ticks: {
          font: {
            size: getFontSize(), // ✅ X-axis labels font
          },
          color: "#333",
        },
        grid: { display: false },
      },
      y: {
        display: true,
        beginAtZero: true,
        title: {
          display: true,
          text: "Number of Patients",
          font: {
            size: getFontSize(), // ✅ Y-axis title font
            weight: "bold",
          },
          color: "#333",
        },
        ticks: {
          stepSize: 1,
          font: {
            size: getFontSize(), // ✅ Y-axis labels font
          },
          color: "#333",
        },
        grid: { display: false },
      },
    },
  };
  const getChartHeight = () => {
    if (window.innerWidth > 3000) return "500px";
    if (window.innerWidth > 2500) return "400px";
    if (window.innerWidth > 1600) return "320px";
    return "250px";
  };

  return (
    <div className="row">
      <div className="col-12">
        <div style={{ width: "100%", height: getChartHeight() }}>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <Bar data={chartData} options={options} key={windowWidth} />
          )}
        </div>
      </div>
    </div>
  );
};
export default Patientbarchart;
